import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './reducers'
import { thunk } from 'redux-thunk'

import createSagaMiddleware from 'redux-saga'
import { watchAuth, watchWorkspace, watchRepository, watchUser } from './sagas'

const sagaMiddleware = createSagaMiddleware()

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(thunk, sagaMiddleware),
  devTools: process.env.REACT_APP_ENV !== 'production'
})

sagaMiddleware.run(watchAuth)
sagaMiddleware.run(watchWorkspace)
sagaMiddleware.run(watchRepository)
sagaMiddleware.run(watchUser)
